import { imagePickerPlugin as e } from "./imagePicker.js";
function g(i) {
  return e({
    label: "🖼️",
    title: "Insert image",
    ...i
  });
}
export {
  g as imagePickerPlugin
};
//# sourceMappingURL=imagePickerPlugin.js.map
